<script>
  import FilterSection from "../Filters/FilterSection.svelte";
  import SortBy from "../SortBy.svelte";

  // PROPS
  export let filterSections = [];
</script>

<div class="modal">
  <div class="modal-body">
    <div class="sections">
      {#each filterSections as filterSection}
        <FilterSection
          key={filterSection.key}
          heading={filterSection.heading}
          inModal={true}
        />
        <hr class="filter-section-border" />
      {/each}
    </div>
    <div id="sort-by">
      <SortBy />
    </div>
  </div>
  <div class="modal-footer" />
</div>

<style>
  .modal {
    height: calc(100vh - 58px - 88px);
    width: 100vw;
    margin: 0;
  }

  .modal-body {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    background: rgba(235, 233, 233, 0.5);
  }

  .sections {
    margin-top: 15px;
    border-top: 2px solid #ebe9e9;
    border-bottom: 1px solid #ebe9e9;
  }

  #sort-by {
    padding: 30px;
  }

  .filter-section-border {
    background: #ebe9e9;
    height: 1px;
    margin: 0;
    padding: 0;
    width: 100%;
  }

  .filter-section-border:first-child {
    margin-top: 15px;
  }
</style>
